// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__XSTJX","btn":"styles_btn__3tooj","tags":"styles_tags__2JK_b","wrapBtn":"styles_wrapBtn__20ifa","acquiringBtn":"styles_acquiringBtn__2qYXs"};